import React, { PropsWithChildren } from 'react';
import { IconNames } from '../icons/Icons';
import styles from './Alert.module.scss';
import { Icon } from '../icons/Icon';
import classNames from 'classnames';

export const Alert = ({
    children,
    className,
    onDismiss,
    icon = 'alert-circle-exclamation',
    type = 'info'
}: Props) => (
    <div className={classes(type, className)}>
        <Icon type={icon} className={styles.icon} />
        <p className={styles.text}>
            {children}
        </p>
        {onDismiss !== undefined && (
            <button onClick={onDismiss}>
                <Icon type='general-ui-close' className={styles.dismiss} />
            </button>
        )}
    </div>
);

const classes = (type: Props['type'], className?: string) => classNames(
    styles.default,
    className,
    {
        [styles.error]: type === 'error',
        [styles.warning]: type === 'warning',
        [styles.info]: type === 'info',
        [styles.success]: type === 'success'
    });

type Props = PropsWithChildren<{
    icon: IconNames,
    className?: string,
    type?: 'success' | 'warning' | 'error' | 'info',
    onDismiss?: () => void
}>;